import baseMethods from "../baseMethods";
import utils from "../../libs/utils"

let auth = {};
let base_url_fjl = baseMethods.fjl_api_proxy;

/*账号密码登录*/
auth.lingYunAuth = (param1) => {
    let param = {
        grant_type: 'password',
        username: param1.username,
        password: param1.password,
    };
    let myURL = base_url_fjl + `/oauth/token?grant_type=${param.grant_type}&username=${param.username}&password=${param.password}`;
    let myHeader = {
        "Content-Type": "application/x-www-form-urlencoded",
        'Authorization': 'Basic YWRtaW46JDBiRXlIaXZlJjJvMVNpeA==',
        'sobeyhive-http-site': 'sobeyLingYunMall'
    };
    return new Promise((resolve, reject) => {
        baseMethods.post(myURL, param, myHeader).then((res) => {
            if (res && res.access_token) {
                resolve(res);
            } else {
                reject(res);
            }
        }).catch((err) => {
            reject(err);
        })
    })
};

// 初次注册初始化用户角色
auth.syncRole = (role_code, payload, site_code) => {
    let myURL = base_url_fjl + `/v1.0/role/users/${role_code}/append`;
    let myHeader = {};
    if (site_code) {
        myHeader = {
            "Content-Type": "application/json;charset=UTF-8",
            'sobeyhive-http-site': site_code
        };
    } else {
        myHeader = {
            "Content-Type": "application/json;charset=UTF-8",
            'sobeyhive-http-site': 'sobeyLingYunMall'
        };
    }

    return new Promise((resolve, reject) => {
        baseMethods.put(myURL, payload, myHeader).then((res) => {
            console.log(res);
            if (res.result === true) {
                resolve("SUCCESS");
            } else {
                reject(res);
            }
        }).catch((err) => {
            reject(err);
        })
    })
};

// 初次用户注册状态
auth.init_state = (payload) => {
    let myURL = base_url_fjl + `/v1.0/user/${payload}/init-status`;
    const myHeader = {
        "Content-Type": "application/json;charset=UTF-8",
        'sobeyhive-http-site': 'sobeyLingYunMall'
    };
    return new Promise((resolve, reject) => {
        baseMethods.put(myURL, {}, myHeader).then((res) => {
            console.log(res);
            if (res.result === true) {
                resolve("SUCCESS");
            } else {
                reject(res);
            }
        }).catch((err) => {
            reject(err);
        })
    })
};

/*账号登出*/
auth.logOut = () => {
    /*认证中心要求，不走中间件*/
    let myURL = '/fjl_api/logout';
    const myHeader = {
        'sobeyhive-http-site': 'sobeyLingYunMall'
    };
    return new Promise((resolve, reject) => {
        baseMethods.get(myURL, {}, myHeader).then((res) => {
            if (res && res.result === true) {
                resolve(res);
            } else {
                reject(res);
            }
        }).catch((err) => {
            reject(err);
        })
    })
};

/*清除中间件token*/
auth.remove_mid_ware_key = (my_user_code) => {
    // let myURL = baseMethods.fjiang6_mid_ip + '/lyc_middle_ware/remove_redis_key/' + my_user_code;
    let myURL = baseMethods.fjiang6_mid_ip + '/lyc_middle_ware/remove_redis_key';
    const myHeader = {
        'sobeyhive-http-site': 'sobeyLingYunMall'
    };
    return new Promise((resolve, reject) => {
        baseMethods.delete(myURL, {}, myHeader).then((res) => {
            if (res) {
                resolve(res);
            } else {
                reject(res);
            }
        }).catch((err) => {
            reject(err);
        })
    })
};

/*校验验证码*/
auth.getVerify = (param) => {
    let myURL = base_url_fjl + `/images/verify?captcha=${param}`;
    const myHeader = {
        'sobeyhive-http-site': 'sobeyLingYunMall',
        'Authorization': 'Basic YWRtaW46JDBiRXlIaXZlJjJvMVNpeA=='
    };
    return new Promise((resolve, reject) => {
        baseMethods.get(myURL, myHeader).then((res) => {
            if (res && res.result === "success") {
                resolve(res);
            } else {
                res.message = "验证码不正确，请输入正确的验证码"
                reject(res);
            }
        }).catch((err) => {
            err.message = "验证码不正确，请输入正确的验证码"
            reject(err);
        })
    })
};

/*获取已登录用户信息*/
auth.userMe = () => {
    let myURL = base_url_fjl + '/v1.0/user/me';
    const myHeader = new Headers({
        'sobeyhive-http-site': 'sobeyLingYunMall',
        'Content-Type': 'application/json;charset=UTF-8',
        'Authorization': baseMethods.temp_token
    });
    return new Promise((resolve, reject) => {
        baseMethods.get(myURL, myHeader).then((res) => {
            if (res) {
                resolve(res);
            } else {
                reject(res);
            }
        }).catch((err) => {
            reject(err);
        })
    })
};

//根据usercode 查询父账号信息
auth.getParentUser = (userCode) => {
    let url = base_url_fjl + "/v1.0/user/parent-user/";
    let myURL = url + userCode;
    const myHeader = new Headers({
        'sobeyhive-http-site': 'sobeyLingYunMall',
        'Content-Type': 'application/json;charset=UTF-8'
    });
    return new Promise((resolve, reject) => {
        baseMethods.get(myURL, myHeader).then((res) => {
            if (res) {
                resolve(res);
            } else {
                reject(null);
            }
        }).catch((err) => {
            reject(err);
        })
    })
}

/*获取支持的第三方登录*/
auth.getCanThird = () => {
    let myURL = base_url_fjl + '/v1.0/third-party/oauth';
    const myHeader = {
        'sobeyhive-http-site': 'sobeyLingYunMall',
        'Authorization': 'Basic YWRtaW46JDBiRXlIaXZlJjJvMVNpeA==',
    };
    return new Promise((resolve, reject) => {
        baseMethods.get(myURL, myHeader).then((res) => {
            if (res) {
                resolve(res);
            } else {
                reject(res);
            }
        }).catch((err) => {
            reject(err);
        })
    })
};

/*第三方登录*/
auth.getThirdLogin = (param) => {
    let myURL = base_url_fjl + param;
    const myHeader = {
        'sobeyhive-http-site': 'sobeyLingYunMall',
        'Authorization': 'Basic YWRtaW46JDBiRXlIaXZlJjJvMVNpeA=='
    }
    return new Promise((resolve, reject) => {
        baseMethods.get(myURL, myHeader).then((res) => {
            if (res) {
                resolve(res);
            } else {
                reject(res);
            }
        }).catch((err) => {
            reject(err);
        })
    })
};

/*获取手机短信验证码*/
//注册的获取验证码传true, 默认为false
auth.getCheckCode = (param) => {
    let myURL = base_url_fjl + `/v1.0/sms-user/check-code?phone=${param.phone}&is_registry=${param.is_registry}`;
    const myHeader = new Headers({
        'sobeyhive-http-site': 'sobeyLingYunMall',
        'Authorization': 'Basic YWRtaW46JDBiRXlIaXZlJjJvMVNpeA=='
    });
    return new Promise((resolve, reject) => {
        baseMethods.postURL(myURL, myHeader).then((res) => {
            if (res && res.result === true) {
                resolve(res);
            } else {
                res.message = "短信发送失败,请稍后再试"
                reject(res);
            }
        }).catch((err) => {
            err.message = "验证码发送失败"
            reject(err);
        })
    })
};

//手机号重复校验
auth.getPhoneRepeat = (param) => {
    let myURL = base_url_fjl + `/v1.0/user/registry/phone/repeat?phone=${param}`;
    const myHeader = {
        'sobeyhive-http-site': 'sobeyLingYunMall',
        'Authorization': 'Basic YWRtaW46JDBiRXlIaXZlJjJvMVNpeA=='
    }
    return new Promise((resolve, reject) => {
        baseMethods.get(myURL, myHeader).then((res) => {
            if (res) {
                resolve(res);
            } else {
                reject(res);
            }
        }).catch((err) => {
            reject(err);
        })
    })
};

//用户名重复校验
auth.getLoginNameRepeat = (param) => {
    let myURL = base_url_fjl + `/v1.0/user/registry/login-name/repeat?login_name=${param}`;
    const myHeader = {
        'sobeyhive-http-site': 'sobeyLingYunMall',
        'Authorization': 'Basic YWRtaW46JDBiRXlIaXZlJjJvMVNpeA=='
    };
    return new Promise((resolve, reject) => {
        baseMethods.get(myURL, myHeader).then((res) => {
            if (res) {
                resolve(res);
            } else {
                reject(res);
            }
        }).catch((err) => {
            reject(err);
        })
    })
};

// 注册接口
auth.postRegistry = (param) => {
    let myURL = base_url_fjl + `/v1.0/user/registry`;
    const myHeader = new Headers({
        'Authorization': 'Basic YWRtaW46JDBiRXlIaXZlJjJvMVNpeA==',
        'Content-Type': 'application/json',
        'sobeyhive-http-site': 'sobeyLingYunMall'
    });
    return new Promise((resolve, reject) => {
        baseMethods.post(myURL, param, myHeader).then((res) => {
            if (res && res.access_token) {
                resolve(res);
            } else {
                reject(res);
            }
        }).catch((err) => {
            reject(err);
        })
    })
};

// 注册用户添加主题
auth.postRestTopic = (param) => {
    let myURL = base_url_fjl + `/v3.0/message/topic`;
    const myHeader = new Headers({
        'Authorization': 'Basic YWRtaW46JDBiRXlIaXZlJjJvMVNpeA==',
        'Content-Type': 'application/json',
        'sobeyhive-http-site': 'sobeyLingYunMall'
    });
    return new Promise((resolve, reject) => {
        baseMethods.post(myURL, param, myHeader).then((res) => {
            console.log(res);
            if (res) {
                resolve(res);
            } else {
                reject(res);
            }
        }).catch((err) => {
            console.log(err);
        })
    })
}

// 密码重置
auth.postResetPWD = (param) => {
    let myURL = base_url_fjl + `/v1.0/password/retrieve`;
    const myHeader = {
        'Authorization': 'Basic YWRtaW46JDBiRXlIaXZlJjJvMVNpeA==',
        'Content-Type': 'application/json',
        'sobeyhive-http-site': 'sobeyLingYunMall'
    };
    return new Promise((resolve, reject) => {
        baseMethods.put(myURL, param, myHeader).then((res) => {
            if (res && res.result === true) {
                resolve(res);
            } else {
                reject(res);
            }
        }).catch((err) => {
            reject(err);
        })
    })
};

/*获取用户被授权的模块资源*/
auth.resource_menus = (user_code) => {
    let myURL = base_url_fjl + `/v1.0/resource/menus/Lingyun_mall/${user_code}`;
    const myHeader = {
        'Content-Type': 'application/json;charset=UTF-8',
        'sobeyhive-http-site': 'sobeyLingYunMall',
        'Authorization': baseMethods.temp_token
    };
    return new Promise((resolve, reject) => {
        baseMethods.get(myURL, myHeader).then((res) => {
            if (res) {
                resolve(res);
            } else {
                reject(res);
            }
        }).catch((err) => {
            reject(err);
        })
    })
};

//去中间件用code换取token, 返回token状态以及该token对应的用户信息。
auth.mid_ware_session_token = (code) => {
    console.log('测试中间件session-token接口____auth.js__code');
    let myURL = baseMethods.fjiang6_mid_ip + '/lyc_middle_ware/user_info_storage?code=' + code + '&portal=' + baseMethods.web_domain;
    return new Promise((resolve, reject) => {
        baseMethods.get(myURL).then((res) => {
            console.log(myURL, res);
            if (res) {
                resolve(res);
            } else {
                reject(res);
            }
        }).catch((err) => {
            reject(err);
        })
    })
};

//县融环境在site下新建admin角色
auth.addUserGroup = (data, site) => {
    let myURL = base_url_fjl + `/v1.0/role`;
    let payLoad = data;
    payLoad.code = utils.generateUUID(32);
    utils.localStorageSet('role_code', payLoad.code);
    const myHeader = {
        'sobeyhive-http-token': baseMethods.temp_token,
        'Content-Type': 'application/json;charset=UTF-8',
        'sobeyhive-http-site': site,
    };
    return new Promise((resolve, reject) => {
        baseMethods.post(myURL, payLoad, myHeader).then((res) => {
            if (res) {
                resolve(res);
            } else {
                reject(res);
            }
        }).catch((err) => {
            reject(err);
        })
    })
};

//请求角色被赋予的资源权限  /v1.0/role/resource/{role_code}
auth.getRoleResource = (roleCode) => {
    let url = base_url_fjl + "/v1.0/role/resource/";
    let myURL = url + roleCode + "?page=1&size=9999";
    const myHeader = new Headers({
        'sobeyhive-http-token': baseMethods.temp_token,
        'Content-Type': 'application/json;charset=UTF-8',
        'sobeyhive-http-site': 'sobeyLingYunMall'
    });
    return new Promise((resolve, reject) => {
        baseMethods.get(myURL, myHeader).then((res) => {
            console.log(res, '权限');
            if (res) {
                resolve(res);
            } else {
                reject(null);
            }
        }).catch((err) => {
            reject(err);
        })
    })
};

//批量给角色赋予权限   /v1.0/role/resource/{role_code}
auth.setRoleResource = (roleCode, myParams, site) => {
    let myURL = base_url_fjl + "/v1.0/role/resource/" + roleCode;
    console.log('roleCode', roleCode);
    console.log('myParams', myParams);
    console.log('site', site);

    const myHeader = new Headers({
        'sobeyhive-http-token': baseMethods.temp_token,
        'Content-Type': 'application/json;charset=UTF-8',
        'sobeyhive-http-site': site
    });
    return new Promise((resolve, reject) => {
        baseMethods.post(myURL, myParams, myHeader, 'no_feedback').then((res) => {
            if (res && res.status) {
                console.log('setRoleResource_String(res.status)', String(res.status), res);
            }
            if (res && res.status && '200' === String(res.status)) {
                resolve(true)
            } else {
                resolve(false)
            }
        }).catch((err) => {
            reject(err);
        })
    })
};

//lgc整合初始化角色的功能
auth.init_user_role_in_all_system = (myParams) => {
    let myURL = baseMethods.task_monitor_api_proxy + "/sobeyMallManage/V1/copy-role";
    console.log('myParams', myParams);

    const myHeader = new Headers({
        'Authorization': baseMethods.temp_token,
        'Content-Type': 'application/json;charset=UTF-8',
        'sobeyhive-http-site': myParams.siteCode
    });
    return new Promise((resolve, reject) => {
        baseMethods.post(myURL, myParams, myHeader).then((res) => {
            console.log('init_user_role_in_all_system-res', res)

        }).catch((err) => {
            reject(err);
        })
    })
};

export default auth;



// WEBPACK FOOTER //
// ./src/api/auth/auth.js